import { useMutation } from 'urql';

import { gql } from 'urql';

export const REMOVE_TICKETS_FROM_CATEGORY = gql`
  mutation RemoveTicketsFromCategory($input: RemoveTicketsFromCategory!) {
    removeTicketsFromCategory(input: $input) {
      success
      total
    }
  }
`;

interface RemoveTicketsFromCategoryInput {
  categoryId: number;
  ticketIds: number[];
}

interface RemoveTicketsFromCategoryResponse {
  removeTicketsFromCategory: {
    success: boolean;
    total: number;
  };
}

export const useRemoveTicketsFromCategory = () => {
  return useMutation<RemoveTicketsFromCategoryResponse, { input: RemoveTicketsFromCategoryInput }>(
    REMOVE_TICKETS_FROM_CATEGORY
  );
};
